import $ from 'jquery'
import 'slick-carousel'
import { slug, isMobile } from 'utils/general'
import { mapState } from 'vuex'

/**
 * Used for product gallery and product zoom gallery
 */
export default {
  data () {
    return {
      hasColorVariants: false
    }
  },
  methods: {
    sanitizedAltText (value) {
      let altString = value
      if (value.includes('|')) {
        altString = value.split('|').pop()
      }
      return altString.replaceAll('"', '')
    },

    startImageFiltering (className) {
      const productSliders = $(className)

      productSliders.slick('slickUnfilter')

      if (this.hasColorVariants) {
        const activeColorFilter = `filter-${slug(this.activeVariant.sku)}`

        this.addFilterClasses(productSliders)
        this.filterImages(activeColorFilter, productSliders)
      }
    },
    addFilterClasses (productSliders) {
      const activeSKU = slug(this.activeVariant.sku)

      productSliders.find('.js-product-slide').each(function () {
        const $this = $(this)
        const colorVariant = $this.data('color-variant')
        const slideClassList = $this.parents('.slick-slide')[0].classList
        const sanitizedClassList = [...slideClassList].filter(x => !x.includes('filter-'))
        $this.parents('.slick-slide')[0].classList = sanitizedClassList.join(' ')

        if (colorVariant.includes('|')) {
          const sanitizedArr = colorVariant.split('|').map(x => slug(x))
          const skuIndex = sanitizedArr.indexOf(activeSKU)

          if (skuIndex > -1) {
            $this.parents('.slick-slide').addClass(`filter-${activeSKU}`)
          }
        }
      })
    },
    filterImages (activeColorHandle, productSliders) {
      productSliders.slick('slickFilter', function () {
        return $(this).attr('class') === activeColorHandle
      })

      this.reIndexSlides(productSliders)
    },
    initializeSliders (sliderClass1, sliderClass2) {
      const slider1 = $(sliderClass1)
      const slider2 = $(sliderClass2)
      let thumbsIsVertical = true

      if (slider2.hasClass('js-product-thumbs-zoom') && window.innerWidth <= 1023) {
        thumbsIsVertical = false
      }

      slider1.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        prevArrow: $('.product-gallery--prev'),
        nextArrow: $('.product-gallery--next'),
        infinite: true,
        asNavFor: slider2,
        fade: !isMobile(),
        cssEase: isMobile() ? 'ease' : 'linear'
      })

      slider2.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: false,
        asNavFor: slider1,
        focusOnSelect: true,
        vertical: thumbsIsVertical,
        verticalSwiping: true
      })
    },
    slug (value) {
      return slug(value)
    },
    checkProductImages () {
      if (!this.activeVariant) {
        return false
      }

      const sku = slug(this.activeVariant.sku)

      this.hasColorVariants = this.product.images.some(image => {
        if (image.alt.includes('|')) {
          const imageAlt = image.alt.split('|').map(x => slug(x))

          return imageAlt.indexOf(sku) > -1
        }
      })
    },
    currentThumbSlide (e) {
      const slide = e.target
      const parent = $(slide).parents('.slick-slide')

      parent.addClass('slick-current').siblings().removeClass('slick-current')
    },
    reIndexSlides ($slick) {
      const slides = $slick.find('.slick-slide:not(.slick-cloned)')

      slides.each(function (index, slide) {
        $(slide).attr('data-slick-index', index)
      })

      $slick.slick('slickGoTo', 0, true)
    },
    replacePagination () {
      const pagination = document.querySelectorAll('.slick-dots')[0]
      const clone = pagination.lastElementChild.cloneNode(true)

      pagination.appendChild(clone)
    }
  },
  computed: {
    ...mapState('product', [
      'product'
    ]),
    ...mapState('product', [
      'activeVariant'
    ]),
    productImages () {
      const filteredImages = this.product.images.filter(image => {
        const altText = image.alt.toLowerCase()

        if (!altText.includes('swatch_')) {
          return image
        }
      })

      return filteredImages
    }
  }
}
